@if (isLoading) {
    <app-dashboard-page-loader></app-dashboard-page-loader>
} @else {
    <div class="flex-space-between flex-align-center pad-L">
        <div class="font-MM fw-700">{{ 'page.agent.workstations.list.widgetName' | translate}}</div>
        <div class="flex gap-XS">
            <div class="flex-align-center search-bar-container bkg-white b-radius-9" [class.disabled]="agents.length === 0">
                <app-text-button [disabled]="agents.length === 0" type="default" color="primary" class="search-btn" panelClass="h-100-imp pad-0-imp"
                                 (click)="openSearchPanel(input)">
                    <div class="flex-center">
                        <img src="assets/icons/search-md.svg" width="14" height="14" alt=""/>
                    </div>
                </app-text-button>
                <div class="flex-space-between">
                    <input #input class="search-input" [ngClass]="{'display-input': openSearch}" [formControl]="this.searchForm"
                           [placeholder]="openSearch ? ('page.data.search'|translate) : ''">
                    <app-text-button (click)="clearSearch(input)" *ngIf="openSearch && searchValue" type="default"
                                     color="primary"
                                     panelClass="h-100-imp pad-0-imp" class="delete-text-button mr-xs">
                        <div class="flex-center">
                            <img src="assets/icons/close.svg" alt="">
                        </div>
                    </app-text-button>
                    <div *ngIf="openSearch && !searchValue" style="width: 16px; height: 22px;">
                    </div>
                </div>
            </div>

            <app-dropdown #filterDropdown>
                <div class="flex-column gap-S" style="width: 300px;">
                    <div class="flex-column gap-S">
                        <span class="font-M fw-500 grey">{{'Version'|translate}}</span>
                        <app-multi-select [inputControl]="filterVersionForm" multiple [addMinHeight]="true">
                            <app-select-trigger appearance="field">
                                {{formatMultiselectLabel(filterVersionForm.value) }}
                            </app-select-trigger>
                            <app-select-option *ngFor="let version of availableVersions" [value]="version">
                                <span>{{version}}</span>
                            </app-select-option>
                        </app-multi-select>

                        <div class="flex w-100" style="margin: 20px -20px -20px -20px; width: calc(100% + 40px);">
                            <app-text-button color="primary" class="w-100" panelClass="bkg-light-grey-2-imp b-radius-bottom-9"
                                             (click)="clearFilters(); filterDropdown.close();">
                                <div class="flex-align-center gap-S" style="margin-left: -15px;">
                                    <img src="assets/icons/close.svg" width="12" height="12" alt=""/>
                                    <span>{{'page.application.table.filters.clear'|translate}}</span>
                                </div>
                            </app-text-button>
                        </div>
                    </div>
                </div>
            </app-dropdown>
            <app-button-widget [disabled]="agents.length === 0" [badge]="filterVersionForm.value?.length || ''" [dropdownTrigger]="filterDropdown">
                <img [class.filter-grey]="agents.length === 0" ngSrc="assets/icons/filter-lines.svg" width="14" height="14" alt="filter">
            </app-button-widget>
        </div>
    </div>

    @if(agents && agents.length > 0) {
        <div class="agent updated pad-left-L pad-right-L pad-bottom-L" style="flex:1;min-height: 0;">
            <app-table-component
                    [noDataMessage]="'page.agent.workstations.list.noAgentFilter'|translate"
                    [loading]="isLoading"
                    [columnDefinitions]="columnDefinitions()"
                    [data]="filteredAgentPaginated || []"
                    [tableHeight]="'100%'"
                    [tableMaxHeight]="height"
                    [clickable]="false"
                    [type]="'drawer'"
                    [style]="'only-table'">
        
                <!-- Custom templates -->
                <ng-template #nameTemplate let-row let-width="width">
                    <div #hostnameElem [tooltip]="row.hostname" [tooltipDisabled]="!isEllipsisActive(hostnameElem)" class="text-overflow-ellipsis" [style.width.px]="width">
                        {{ row.hostname }}
                    </div>
                </ng-template>
                <ng-template #versionTemplate let-row>
                    <div class="flex-center text-overflow-ellipsis">
                        {{ row.agentVersion }}
                    </div>
                </ng-template>
                <ng-template #teamTemplate let-row let-width="width">
                    <div class="flex-center w-100">
                        <app-chips-text [tooltip]="row.teamPath" [bold]="false">
                            <div class="flex-align-center gap-XS">
                                <div class="text-overflow-ellipsis" [style.max-width.px]="width - 55">{{ row.team }}</div>
                                <img ngSrc="assets/icons/info-black.svg" height="16" width="16" alt="info"/>
                            </div>
                        </app-chips-text>
                    </div>
                </ng-template>
                <ng-template #usernameTemplate let-row let-width="width">
                    <div #nameElem class="text-overflow-ellipsis" [style.width.px]="width" [tooltip]="row.userRealname" [tooltipDisabled]="!isEllipsisActive(nameElem)">
                        {{ row.userRealname }}
                    </div>
                </ng-template>
                <ng-template #statusTemplate let-row>
                    <div class="flex-center">
                        <div *ngIf="row.status === 'active'" class="signal signal-success" [tooltip]="'page.agent.workstations.list.agentStateOk'|translate" tooltipPosition="right">
                            <img ngSrc="../../../../../../assets/icons/signal.svg" class="filter-success" width="20" height="20" alt="status">
                        </div>
                        <div *ngIf="row.status !== 'active'" class="signal signal-secondary" [tooltip]="'page.agent.workstations.list.agentStateKo'|translate" tooltipPosition="right">
                            <img ngSrc="../../../../../../assets/icons/signal.svg" class="filter-grey" width="20" height="20" alt="status">
                        </div>
                    </div>
                </ng-template>

                <ng-template #footer>
                    <app-text-button type="stroked" color="grey" *ngIf="pageSize < filteredAgents.length" (click)="increasePageSize()">Voir plus</app-text-button>
                </ng-template>
            </app-table-component>
        </div>
    } @else {
        <div class="flex-align-center flex-justify-center h-90 flex-column w-100 gap-XXL">
            <img ngSrc="assets/illustrations/no-agent-installed.svg" alt="No agent" width="191" height="175"/>
            <div class="grey font-L">{{ 'page.agent.workstations.list.noAgentDeployedYet' | translate}}</div>
            <app-text-button size="compact" color="grey" (click)="openDocumentation()"  type="stroked">
                <img ngSrc="assets/icons/info-black.svg" alt="Documentation" width="20" height="20"/>
                <span class="pad-left-XS">{{ 'page.agent.workstations.list.howToDeploy' | translate }} </span>
            </app-text-button>
        </div>
    }
}